<template>
  <el-card>
    <el-row :gutter="20" class="header">
      <el-col :span="7">
        <el-input placeholder="请输入用户昵称..." clearable v-model="queryForm.query"></el-input>
      </el-col>
      <el-button type="primary" :icon="Search" @click="initList">搜索</el-button>
    </el-row>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="id" label="编号" width="80" />
      <el-table-column prop="nickName" label="用户昵称" width="200" />
      <el-table-column prop="operateCoin" label="充值技豆" width="120" />
      <el-table-column prop="totalCoin" label="剩余技豆" width="120" />
      <el-table-column prop="remark" label="备注" width="250" />
      <el-table-column prop="createTime" label="充值时间" width="200" />
      <el-table-column prop="updateTime" label="更新时间" width="200" />
    </el-table>

    <el-pagination
      v-model:currentPage="queryForm.pageNum"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryForm.pageSize"
      :small="small"
      :disabled="disabled"
      :background="background"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </el-card>
</template>

<script setup>
import { Search } from '@element-plus/icons-vue'
import { ref } from 'vue'
import axios from '@/util/axios'

const queryForm = ref({
  query: '',
  pageNum: 1,
  pageSize: 10
})

const total = ref(0)
const tableData = ref([])

const initList = async () => {
  const res = await axios.post('admin/coinRecord/list', queryForm.value)
  if (res.data.code === 0) {
    tableData.value = res.data.records || []
    total.value = res.data.total || 0
  }
}

initList()

const handleSizeChange = (pageSize) => {
  queryForm.value.pageNum = 1
  queryForm.value.pageSize = pageSize
  initList()
}

const handleCurrentChange = (pageNum) => {
  queryForm.value.pageNum = pageNum
  initList()
}
</script>

<style lang="scss" scoped>
.header {
  padding-bottom: 16px;
  box-sizing: border-box;
}

.el-pagination {
  padding-top: 15px;
  box-sizing: border-box;
}
</style>